import { Component } from "vuety";
import { IProductGroupItem } from "../../interfaces";
import { getRoot, findChild } from "../../root";
import { BaseView } from "../base";
import { TreeList } from "./treeList";
import Vue from "vue";

const templateElement = "v-tmpl-grouptree";

@Component({
  template: document.getElementById(templateElement)
    ? "#" + templateElement
    : require("./tree.html"),
  components: { "tree-list": TreeList },
  mixins: [BaseView]
})
export class TreeView extends Vue {
  public get groups(): IProductGroupItem[] {
    if (this.options.rootGroup) {
      const child = findChild(
        this.options.rootGroup,
        getRoot().currentData.Groups
      );
      if (!child) {
        console.warn(
          "No group data found for root group:",
          "'" + this.options.rootGroup + "'.",
          "This may be because the group is obsolete."
        );
        return [];
      }
      return child.Children;
    } else {
      return getRoot().currentData.Groups;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/tree/tree.ts